/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
import { PublicClientApplication } from '@azure/msal-browser';
import { getTokenWithRedirectFallback } from '@tq/auth-components';
import { getAuthPaths } from '../auth';

let _pca: PublicClientApplication;
export const setPca = (pca: PublicClientApplication) => {
  _pca = pca;
};

export class IConfig {
  /**
   * Returns a valid value for the Authorization header.
   * Used to dynamically inject the current auth header.
   */
  async getAuthorization() {
    const token = await getTokenWithRedirectFallback(_pca, process.env.REACT_APP_B2C_SCOPE!, getAuthPaths());
    return `Bearer ${token}`;
  }
}

export class AuthorizedApiBase {
  private readonly config: IConfig;

  protected constructor(config: IConfig) {
    this.config = config;
  }

  protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      Authorization: await this.config.getAuthorization(),
    };
    return Promise.resolve(options);
  };
}
